import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const updateManagePassword = createAsyncThunk(
  "candidate/updateManagePassword",
  async ({ userId, data }, { rejectWithValue }) => {
    try {
      const response = await axiosPrivate.post(
        `${api.employeeChangePassword}${userId}`,
        data
      );
      return response.data;
    } catch(error) {
      return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
    }
  }
);

const managePasswordApiSlice = createSlice({
  name: "managePasswordApi",
  initialState: {
    managePassword: {},
    status: "idle",
    loading: false,
    error: null,
  },
  reducers: {
    resetState: (state) => {
      state.managePassword = {};
      state.status = 'idle';
    }
  },
  extraReducers: (builders) => {
    builders
      .addCase(updateManagePassword.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
      })
      .addCase(updateManagePassword.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
        state.managePassword = action.payload;
      })
      .addCase(updateManagePassword.rejected, (state, action) => {
        state.status = "failed";
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const { resetState } = managePasswordApiSlice.actions;
export default managePasswordApiSlice.reducer;
